<div class="mobile-shell">

    <!-- Header -->
  
    <main class="screen-content">
      
      <!--<br />
        <p-select [options]="countries" [(ngModel)]="selectedCountry" optionLabel="label" optionValue="value" placeholder="Select a location" class="w-full md:w-56" />
      <br />-->

      <!--<div class="transfer-container">-->

        <h4>Where are you transferring from?</h4>
    
        <!-- Country -->
        <div class="dropdown-field">
            <!--<label *ngIf="selectedCountry" for="location" class="dropdown-label">Your bank location *</label>
            <p-dropdown
                id="location"
                [options]="countries"
                optionLabel="label"            
                optionValue="flag"
               [(ngModel)]="selectedCountry"
                placeholder="Your bank location *">

            </p-dropdown>-->
            <label *ngIf="selectedCountry" for="location" class="dropdown-label">Your bank location *</label>
            <p-dropdown
              [options]="countries"
              [(ngModel)]="selectedCountry"
              optionLabel="label"
              (onChange)="selectCountry($event)"
              placeholder="Your bank location *">

              <ng-template let-country pTemplate="item">
                  <div class="country-item">
                    <span class="{{ country.flag }}"></span>
                    <span>{{ country.label }}</span>
                  </div>
              </ng-template>

              <ng-template let-country pTemplate="selectedItem">
                  <div
                      class="country-item"
                      *ngIf="country">

                      <span class="{{ country.flag }}"></span>
                      <span>{{ country.label }}</span>
                  </div>
              </ng-template>

          </p-dropdown>

       </div>
       <!--[class.country-option-selected]="selectedCountry?.value === country.value"-->
        <div class="help-text">
            <i class="pi pi-info-circle"></i>
            Can't find your country?
        </div>
    
        <!-- Purpose -->
        <div class="dropdown-field">
           <label *ngIf="selectedPurpose"  for="purpose" class="dropdown-label">Purpose of funds *</label>
    
            <p-dropdown
                for="purpose"
                [options]="purposes"
                optionLabel="label"
                optionValue="value"
                (onChange)="onPurposeChange($event)"
                (click)="onclick($event)"
                [(ngModel)]="selectedPurpose"
                placeholder="Purpose of funds *">
            </p-dropdown>
        </div>

        <br />
    
        <div class="outlined-field"
            *ngIf="selectedPurpose === 'other'">
    
            <label for="otherPurpose" class="outlined-label">Enter other purpose of funds</label>
    
            <input
                id="otherPurpose"
                pInputText
                (onchange)="onOtherPurpose($event)"
                [(ngModel)]="customPurpose"
                class="amount-field" />
        </div>

        <br />
    
    <!--</div>-->

      <!-- Currency tabs -->
      <div class="tab-shell">
        <button
          type="button"
          class="tab-button"
          [class.tab-button-active]="selectedTab !== 'UGX'"
          (click)="selectTab(selectedCountry.currency || 'EUR')"
        >
          Amount in {{selectedCountry.currency || 'EUR'}}
        </button>
  
        <button
          type="button"
          class="tab-button"
          [class.tab-button-active]="selectedTab === 'UGX'"
          (click)="selectTab('UGX')"
        >
          Amount in UGX
        </button>
      </div>
  
      <!-- Amount field -->
      <div class="amount-field-wrapper" [class.amount-field-error]="amountHasError">
  
        <!--<span class="amount-floating-label" *ngIf="amountHasError">
          Amount *
        </span>-->
  
        <div class="amount-container" [class.amount-container-error]="amountHasError">
          <label *ngIf="amountHasError"
          [class.amount-label-error]="amountHasError">
            Amount *
          </label>

          <span class="currency-label"
           [class.currency-label-error]="amountHasError">
            {{ selectedCurrency() }}
          </span>
  
          <input
            placeholder="Amount *"
            class="amount-input"
            [class.amount-input-error]="amountHasError"
            type="number"
            [(ngModel)]="amount"
            [min]="minAmount"
            [max]="maxAmount"
            (blur)="updateConvertedAmount()"
            (input)="onAmountInput()"
            inputmode="decimal"
          />
        </div>
        <div class="amount-info" *ngIf="!amount">
          Minimum amount is {{ (minAmount ?? (selectedTab === 'UGX' ? 4053.77 : 1)) | number: '1.0-2' }} {{ selectedCurrency() }} 
        </div>
      </div>
        
      <div class="amount-error-message" *ngIf="amountHasError">
        {{this.fxRate.data.limits.message}}
      </div>
  
      <!-- Rate summary -->
      <section class="summary-card">
        <div *ngIf="isQuoteLoading && !this.fxRate" style="text-align: center; padding: 12px; color: #004F71;">
          <i class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-right: 8px;"></i>
          <span>Fetching live quote...</span>
        </div>

        <div *ngIf="quoteError && !isQuoteLoading" style="padding: 10px; color: #c5221f; font-size: 13px; text-align: center;">
          <i class="pi pi-exclamation-triangle" style="margin-right: 6px;"></i>
          <span>{{ quoteError }}</span>
          <div style="margin-top: 8px;">
            <button pButton label="Retry Quote" class="p-button-sm p-button-outlined" (click)="paymentQuote()"></button>
          </div>
        </div>

        <div *ngIf="this.fxRate && !quoteError" [class.summary-updating]="isQuoteLoading">
          <div class="summary-row">
            <span>You pay</span>
            <strong>{{ this.fxRate.data.sourceAmount | number: '1.2-2' }} {{ this.fxRate.data.sourceCurrency }}</strong>
          </div>
    
          <div class="summary-row">
            <span>Exchange rate</span>
            <span>
              <i *ngIf="isQuoteLoading" class="pi pi-spin pi-spinner" style="font-size: 0.75rem; margin-right: 4px; color: #005f7c;"></i>1 {{ this.fxRate.data.sourceCurrency }} = {{ this.fxRate.data.creditedCurrency }} {{ this.fxRate.data.fxRate }}
            </span>
          </div>
    
          <div class="receive-row">
            <strong>You’ll get</strong>
            <strong>{{ this.fxRate.data.creditedCurrency }} {{ this.fxRate.data.creditedAmount | number: '1.2-2' }}</strong>
          </div>
        </div>
      </section>

      
  
      <!-- Purpose dropdown -->
      <!--<section class="purpose-select">
        <button
          type="button"
          class="purpose-trigger"
          (click)="togglePurpose()"
        >
          <span>
            {{ selectedPurpose?.label || 'Purpose of funds *' }}
          </span>
      
          <i class="pi"
             [class.pi-chevron-down]="!purposeOpen"
             [class.pi-chevron-up]="purposeOpen">
          </i>
        </button>
      
        <div class="purpose-options" *ngIf="purposeOpen">
          <button
            type="button"
            class="purpose-option"
            *ngFor="let purpose of purposes"
            (click)="selectPurpose(purpose)"
          >
            {{ purpose.label }}
          </button>
        </div>
      </section>

      <section class="amount-field" *ngIf="selectedPurpose?.value === 'other'">
        <input
        class="amount-input"
        type="string"
        placeholder="Enter custom purpose"
        [(ngModel)]="customPurpose"
        (blur)="updateConvertedAmount()"
      />
      </section>-->
      
      <!-- Info text -->
      <div class="rate-note">
        <i class="pi pi-info-circle"></i>
        <span>
          The exchange rate will be locked once you confirm the transfer.
        </span>
      </div>
  
      <!-- Next button -->
      
    </main>
    <footer class="screen-footer">
      <button
        pButton
        type="button"
        label="NEXT"
        class="next-button"
        [disabled]="nextDisabled"
        (click)="goNext()"
      ></button>
    </footer> 

  </div>
  